//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//API URL
//export const apiEndpoint = "http://172.16.15.48:86/IndusV2WebAPI/api/Indus";//Test Server
//export const apiEndpoint = "http://103.176.134.139:86/IndusV2WebAPI/api/Indus";//Test Server Public IP
//export const apiEndpoint = "https://localhost:44327/api/Indus";//Local
//export const apiEndpoint = "https://www.adorindus.com/IndusV2WebAPI/api/Indus";//Production
export const apiEndpoint = "https://cvasssecjmdqa.ril.com/IndusV2WebAPI/api/Indus";// RIL






